import Vue from 'vue'
import Axios from 'axios'
import { get } from 'jquery'

export default {//经常调用的接口
    // wrong_Statistics({ state, commit },_type) {  //埋点
    //     // 1 数学小题详情页视频开通按钮
    //     // 2 查看错题解析按钮
    //     // 3 立即订购按钮
    //     return new Promise((resolve, reject) => {
    //         Axios.post(API_URL_HD + '/wrong_question_clear/statistics/ ', {"type":_type}).then(res => {
    //             resolve();
    //         })
    //     })
    // },

    /* 检测第一次生成任务弹券 */
    getFirstTaskCoupon({ state, commit }) {

        
            // get(API_SERVER + '/task/getFirstTaskCoupon', {
            //     "task_id": state.task_id
            // }).then(res => {
            //     if (res.data.code == 200) {
            //         commit('setFirstTaskCoupon', res.data.data)
            //         resolve(res.data.data)
            //     }
            // })
    }
}
